import React from "react";
import { Tabs, TabsProps } from "antd";

/** Hides tabs bar when has only one item */
export const TabsWrapper = React.memo<TabsProps>((props) => {
  return <Tabs {...props} {...props.items && props.items.length < 2 && { tabBarStyle: { display: "none" } }} />;
});
